<script setup lang="ts">
import { DialogCloseButton, DialogDrawer } from '@ilteducation/components';

defineProps<{
  modelValue: boolean;
  title: string;
  subtitle?: string;
  testId: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void;
}>();

const close = () => emit('update:modelValue', false);
</script>

<template>
  <DialogDrawer :model-value="modelValue" :titleText="title" maxWidth="720" @close="close">
    <template #dialogTopbar>
      <DialogCloseButton @click="close" />
      <v-card-title class="chalkduster-font text-h6 px-0 pe-10">{{ title }}</v-card-title>
    </template>

    <div :data-testid="testId">
      <p v-if="subtitle" class="text-caption on-surface-medium mb-3">{{ subtitle }}</p>

      <!-- Own scroll container: DialogDrawer's card is `overflow: hidden !important`. -->
      <div class="overflow-y-auto" style="max-height: 60vh">
        <slot />
      </div>
    </div>
  </DialogDrawer>
</template>
